import Modal from "components/layout/modal";
import PDFRenderer from "components/core/pdf-renderer";
import { useFormik } from "formik";
import { BrokerTypes } from "graphql/__generated__/globalTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { getUrl } from "../../../utils/helpers";

const documentTabs = [
    {
        name: "Placing Slip",
        href: "PLACING_SLIP",
    },
    {
        name: "Closing Slip",
        href: "CLOSING_SLIP",
    },
];

interface TreatyDocumentViewerProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    treaty: any;
    treatyAccountId?: string;
    layer?: any;
    layerNumber?: number;
}

const TreatyDocumentViewer = ({
    open,
    setOpen,
    treaty,
    treatyAccountId,
    layer,
    layerNumber,
}: TreatyDocumentViewerProps) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("PLACING_SLIP");
    const [loading, setLoading] = useState(false);

    const { broker } = useAppSelector((state) => state.offers);

    const form = useFormik({
        initialValues: {
            lang: "en",
        },
        onSubmit: () => {},
    });

    const isProp =
        treaty?.treaty?.treaty_program?.treaty_type === "PROPORTIONAL";

    const getDocumentUrl = () => {
        const urls: { [key: string]: string } = {
            PLACING_SLIP: getUrl(
                {
                    treaty_id: treaty?.treaty?.treaty_id,
                    doc_type: "PLACING",
                    emp_id: "1",
                },
                "treaty_placing_cover_note",
                broker as BrokerTypes,
            ),
            CLOSING_SLIP: getUrl(
                isProp
                    ? {
                          participant_id: treaty?.treaty_participation_id,
                          treaty_account_id: treatyAccountId,
                          type: 0,
                          emp_id: 1,
                      }
                    : {
                          participant_id: treaty?.treaty_participation_id,
                          limit: layer?.limit,
                          layer: layerNumber ? layerNumber + 1 : 1,
                          uuid: layer?.uuid,
                          m_and_d_premium: layer?.m_and_d_premium,
                          total_participation_percentage:
                              treaty?.treaty_participation_percentage,
                          installment_type: layer?.installment_type,
                      },
                treaty?.treaty?.treaty_program?.treaty_type === "PROPORTIONAL"
                    ? "generate_treaty_credit_note"
                    : "treaty_np_credit_note",
                broker as BrokerTypes,
            ),
        };

        return urls[activeTab] || "";
    };

    const handleTabChange = (tabKey: string) => {
        setActiveTab(tabKey);
    };

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={loading}
            title={t("modal_titles.treaty_documents")}
            description={t("documents.view_documents")}
            size="6xl">
            <div className="flex flex-col h-full">
                <div className="border-b border-gray-200">
                    <nav
                        className="-mb-px flex space-x-8 px-4"
                        aria-label="Tabs">
                        {documentTabs.map((tab) => {
                            const isActive = activeTab === tab.href;

                            return (
                                <button
                                    key={tab.name}
                                    onClick={() => handleTabChange(tab.href)}
                                    className={`${
                                        isActive
                                            ? "border-green-500 text-green-600"
                                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                    } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
                                    aria-current={
                                        isActive ? "page" : undefined
                                    }>
                                    {tab.name}
                                </button>
                            );
                        })}
                    </nav>
                </div>

                <div className="flex-1 p-4">
                    <PDFRenderer url={getDocumentUrl()} />
                </div>
            </div>
        </Modal>
    );
};

export default TreatyDocumentViewer;
